import { HttpInterceptorFn } from "@angular/common/http";
import { inject, Injector } from "@angular/core";
import { KeycloakService } from "../services/keycloak.service";
import { environment } from "../../environments/environment";
import { catchError, filter, from, switchMap, take, throwError } from "rxjs";
import { isExternalUrl } from "../utils/request";
import { toObservable } from "@angular/core/rxjs-interop";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const keycloakService = inject(KeycloakService);
    const injector = inject(Injector);

    if (environment.keycloak.enabled === false || isExternalUrl(req.url)) {
        return next(req);
    }

    return toObservable(keycloakService.isInitialized, { injector }).pipe(
        filter(ready => ready === true),
        take(1),
        switchMap(() => {
            const token = keycloakService.getToken();

            if (!token) {
                return next(req);
            }

            return from(keycloakService.refreshToken()).pipe(
                catchError((error) => {
                    return throwError(() => error);
                }),
                switchMap(() => {
                    const freshToken = keycloakService.getToken();

                    return next(req.clone({
                        setHeaders: {
                            Authorization: `Bearer ${freshToken}`
                        }
                    }));
                }),
            );
        })
    );
};